export enum DriverSafetyActionTypes {
    SET_DRIVER_SAFETY_INSIGHT = "SET_DRIVER_SAFETY_INSIGHT",
    CLEAR_DRIVER_SAFETY_INSIGHT = "CLEAR_DRIVER_SAFETY_INSIGHT"
}

export interface IDriverSafetyDataStore {
    crashProbabilityKm?: number;
    crashProbabilityMile?: number;
    crashProbabilityBenchmarkKm?: number;
    crashProbabilityBenchmarkMile?: number;
    harshAccelerationRange?: string;
    harshAccelerationRank?: number;
    harshBrakingRange?: string;
    harshBrakingRank?: number;
    harshCorneringRange?: string;
    harshCorneringRank?: number;
    speedingRange?: string;
    speedingRank?: number;
    observationDate: string;
    tailgatingRank?: number;
    tailgatingRange?: string;
    metadata?: any;
    crashProbabilityBestInClassKm?: number;
    crashProbabilityBestInClassMile?: number;
    crashProbabilityRange?: string;
    crashProbabilityRank?: number;
    majorVersion?: number;
}

export interface ISafetyDriverInsight {
    id: string;
    crashProbabilityKm?: number;
    crashProbabilityMile?: number;
    crashProbabilityBenchmarkKm?: number;
    crashProbabilityBenchmarkMile?: number;
    harshAccelerationRange?: string;
    harshAccelerationRank?: number;
    harshBrakingRange?: string;
    harshBrakingRank?: number;
    harshCorneringRange?: string;
    harshCorneringRank?: number;
    speedingRange?: string;
    speedingRank?: number;
    observationDate: string;
    tailgatingRank?: number;
    tailgatingRange?: string;
    metadata?: any;
    crashProbabilityBestInClassKm?: number;
    crashProbabilityBestInClassMile?: number;
    crashProbabilityRange?: string;
    crashProbabilityRank?: number;
    majorVersion?: number;
}
